import { render, staticRenderFns } from "./CarbonEmission.vue?vue&type=template&id=2bfc47d0&scoped=true&"
import script from "./CarbonEmission.vue?vue&type=script&lang=js&"
export * from "./CarbonEmission.vue?vue&type=script&lang=js&"
import style0 from "./CarbonEmission.vue?vue&type=style&index=0&id=2bfc47d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfc47d0",
  null
  
)

export default component.exports